import { makeAutoObservable } from 'mobx';

export class ModalsStore {
    IS_LOGIN_OPEN = false;
    IS_REGISTER_OPEN = false;
    IS_LOCATION_OPEN = false;
    IS_UNACCESSED_OPEN = false;
    IS_QUESTION_FORM = false;

    constructor() {
        makeAutoObservable(this);
    }

    openLoginForm = () => {
        this.IS_LOGIN_OPEN = true;
    };
    closeLoginForm = () => {
        this.IS_LOGIN_OPEN = false;
    };
    openRegisterForm = () => {
        this.IS_REGISTER_OPEN = true;
    };
    closeRegisterForm = () => {
        this.IS_REGISTER_OPEN = false;
    };
    openLocationForm = () => {
        this.IS_LOCATION_OPEN = true;
    };
    closeLocationForm = () => {
        this.IS_LOCATION_OPEN = false;
    };
    openUnaccessedForm = () => {
        this.IS_UNACCESSED_OPEN = true;
    };
    closeUnaccessedForm = () => {
        this.IS_UNACCESSED_OPEN = false;
    };
    openQuestionForm = () => {
        this.IS_QUESTION_FORM = true;
    };
    closeQuestionForm = () => {
        this.IS_QUESTION_FORM = false;
    };
}
